// extracted by mini-css-extract-plugin
export default {"innerWrapper":"EB-z","tooltipWrapper":"FB-z","icon":"GB-z","tooltip":"HB-z","content":"IB-z"};